import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiHealthState, subscribeApiHealth } from '../../core/apiHealth';
import { IconExclamationMark } from '../../sites/default/pages/comm/demandLikeList/DemandLikeListIcons';

/**
 * 백엔드 다운·프록시 장애·네트워크 단절 시 상단 고정 안내 배너.
 */
const ApiHealthBanner = () => {
  const { t } = useTranslation();
  const [snapshot, setSnapshot] = useState(() => getApiHealthState());

  useEffect(() => subscribeApiHealth(setSnapshot), []);

  const onReload = useCallback(() => {
    window.location.reload();
  }, []);

  if (!snapshot.degraded) return null;
  const messageText = t(snapshot.messageKey || 'apiHealth.message.default');
  const titleText = t('apiHealth.title');
  const refreshText = t('apiHealth.action.refresh');

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="api-health-fallback"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2147483000,
        background: '#f8fafc',
        color: '#0f172a',
        padding: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        role="alert"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2147483001,
          background: '#9a3412',
          color: '#fff',
          fontSize: 13,
          lineHeight: 1.45,
          padding: '8px 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          textAlign: 'center',
        }}
      >
        <strong style={{ fontWeight: 700 }}>{titleText}</strong>
        <span>
          {messageText}
          {snapshot.status != null ? <span> (HTTP {snapshot.status})</span> : null}
        </span>
      </div>
      <div
        style={{
          width: 'min(560px, 92vw)',
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: 12,
          padding: '24px 22px',
          boxShadow: '0 12px 30px rgba(15, 23, 42, 0.12)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            margin: '0 auto 14px',
            width: 80,
            height: 80,
            borderRadius: 999,
            background: '#fee2e2',
            color: '#b91c1c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconExclamationMark size={52} />
        </div>
        <h3 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 700 }}>{titleText}</h3>
        <p style={{ margin: 0, fontSize: 14, color: '#334155', lineHeight: 1.55 }}>
          {messageText}
          {snapshot.status != null ? <span> (HTTP {snapshot.status})</span> : null}
        </p>
        <div style={{ marginTop: 18, display: 'flex', justifyContent: 'center' }}>
          <button
            type="button"
            onClick={onReload}
            aria-label={refreshText}
            title={refreshText}
            style={{
              border: '1px solid #cbd5e1',
              background: '#fff',
              color: '#334155',
              borderRadius: 8,
              width: 40,
              height: 34,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiHealthBanner;
